// extracted by mini-css-extract-plugin
export default {"container":"SP-z","darkBackground":"TP-z","whiteBackground":"UP-z","headerButton":"VP-z","calloutHeading":"WP-z","calloutSubHeading":"XP-z"};